import { Styles, generateClasses } from 'netline-ui';

export const mobileProfileMenuDialogClasses = generateClasses('MobileUserInfo', ['root', 'paper'] as const);

const styles: Styles = () => ({
  [`.${mobileProfileMenuDialogClasses.paper}`]: {
    width: '100%',
  },
});

export default styles;
